import Swiper, { Autoplay, Pagination } from 'swiper'; 
Swiper.use([Pagination, Autoplay]);

export default class OrderStepsSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.slider = this.root.querySelector('[data-swiper-slider-swiper]');
        this.pins = this.root.querySelector('[data-swiper-slider-pagination]');
        this.swiper = null; 

        return true;
    }

    init() {
        this.initSwiper();
    }

    initSwiper() {
        if (!this.slider) return;

        this.swiper = new Swiper(this.slider, {
            slidesPerView: 'auto',
            autoplay: {
                delay: 2000,
            },
            pagination: {
                el: this.pins,
                clickable: true,
                bulletClass: 'swiper-pagination-bullet order-steps__pin',
                bulletActiveClass: 'swiper-pagination-bullet-active order-steps__pin',
            }
        });
    }
}